import { QuoteForm } from "@/components/site/QuoteForm";
import { MaskLines, Reveal } from "@/components/site/Motion";
import { SITE } from "@/lib/site";
import { Phone, Clock, ShieldCheck } from "lucide-react";

export default function DevisPage() {
  return (
    <main data-testid="devis-page" className="bg-paper px-5 pt-36 pb-24 sm:px-8">
      <div className="mx-auto grid max-w-[1400px] gap-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="eyebrow text-gold-deep mb-6">Devis gratuit · réponse sous 24h</p>
          <h1 className="font-display text-5xl sm:text-6xl leading-[0.98]">
            <MaskLines onLoad lines={["Votre projet,", <em key="e" className="text-clay">chiffré avec soin.</em>]} />
          </h1>
          <Reveal className="mt-10 space-y-6 text-slate-700">
            <p>Quelques questions pour bien comprendre votre besoin : nous vous rappelons pour fixer une visite technique gratuite, puis vous recevez un devis détaillé sous 48h.</p>
            <a href={SITE.phoneHref} className="flex items-center gap-3 font-display text-3xl text-ink" data-testid="devis-page-phone"><Phone className="h-5 w-5 text-gold-deep" />{SITE.phone}</a>
            <p className="flex items-center gap-3 text-sm"><Clock className="h-4 w-4 text-gold-deep" />{SITE.hours[0][0]} · {SITE.hours[0][1]}</p>
            <p className="flex items-center gap-3 text-sm"><ShieldCheck className="h-4 w-4 text-gold-deep" />Garantie décennale · Peintures Écolabel</p>
          </Reveal>
        </div>
        <div className="lg:col-span-8 border-t border-paper-line pt-10 lg:border-t-0 lg:border-l lg:pl-14 lg:pt-0">
          <QuoteForm />
        </div>
      </div>
    </main>
  );
}
